import styled from 'styled-components';
import { StyledLeadText } from '@whitelabel/component-library';
import { fontSize } from '@whitelabel/helpers/style/type';
import { mediaBreakpointUp, marginBottom } from '@whitelabel/helpers/style/grid';
import { multiply } from '@whitelabel/helpers/style/units';
import StyledHeadingBlock from '../../styled/StyledHeadingBlock';

export const StyledSignUpHeadingBlock = styled(StyledHeadingBlock)`
  ${marginBottom}
  ${StyledLeadText} {
    ${mediaBreakpointUp('md')`
      font-size: ${multiply(fontSize('base'), 1.125)};
    `}
  }
`;
